module.exports = __webpack_public_path__ + "static/img/partner-lenkor.a830ce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-lenkor.png
// module id = eILo
// module chunks = 34